export const MANGLISH_LAYOUT = {
    a: 'അ', a2: 'ആ', a3: 'എ', //a4:'ാ', 
    aa: 'ആ', 
    A: 'ആ', A2: 'എ', //A3: 'ാ', 
    i: 'ഇ', i2: 'ഈ', i3: 'ഐ', //i4: 'ി', i5: 'ീ',
    ii: 'ഈ', I: 'ഈ', I2: 'ഐ', ee: 'ഈ', ee2: 'ഏ',
    u: 'ഉ', u2: 'ഊ', u3: 'യു', //u4: 'ു', u5: 'ൂ',
    uu: 'ഊ', oo: 'ഊ', U: 'ഊ', RR: 'ഋ', rr: 'ഋ', 
    e: 'എ', e2: 'ഇ', E: 'ഏ', E2: 'ഇ', ae: 'ഏ', 
    ai: 'ഐ', ei: 'ഐ',
    o: 'ഒ', o2: 'ൊ', o3: 'ോ', O: 'ഓ', 
    au: 'ഔ', ou: 'ഔ', aH: 'അഃ', 
    '~': '\u200C', '_': '\u200C', '^': '്', '@': '@', '@a': '@a', '@0': '൦',
    '@1': '൧', '@2': '൨', '@3': '൩', '@4': '൪', '@5': '൫', '@6': '൬', 
    '@7': '൭', '@8': '൮', '@9': '൯', '@aa': 'ാ', '@A': 'ാ', '@i': 'ി',
    '@ii': 'ീ', '@I': 'ീ', '@ee': 'ീ', '@u': 'ു', '@uu': 'ൂ', '@U': 'ൂ', 
    '@oo': 'ൂ', '@R': 'ൃ', '@e': 'െ', '@E': 'േ', '@ae': 'േ',
    '@o': 'ൊ', '@O': 'ോ', '@ai': 'ൈ', '@ei': 'ൈ', '@ou': 'ൌ', 
    '@ou2': 'ൗ', '@au': 'ൌ', '@au2': 'ൗ',
    k: 'ക്', k2: 'കെ', k3: 'ക്ക്',
    'k~': 'ക്\u200D',
    'k_': 'ക്\u200D',
    'c~': 'ക്\u200D',
    'c_': 'ക്\u200D',
    c: 'ക്', c2: 'സി',
    ck: 'ക്ക്',
    ka: 'ക', ka2: 'ഗ', ka3: 'ഖ', ka4: 'ഘ',
    ca: 'ക്യാ', ca2: 'കാ', ca3: 'കേ',
    kaa: 'കാ', kaa2: 'ഗാ',
    caa: 'കാ',
    kA: 'കാ',
    cA: 'കാ',
    ki: 'കി', ki2: 'ഗി', ki3: 'ഖി', ki4: 'ഘി', ki5: 'കൈ',
    ci: 'സി', ci2: 'കി', ci3: 'സൈ',
    cy: 'സി',
    ncy: 'ൻസി',
    nci: 'ൻസി',
    ndr :'ന്ദ്ര്', ndra :'ന്ദ്ര', ndraa :'ന്ദ്രാ', ndrA :'ന്ദ്രാ', ndru :'ന്ദ്രു', ndruu :'ന്ദ്രൂ', ndrU :'ന്ദ്രൂ', 
    ndroo :'ന്ദ്രൂ', ndre :'ന്ദ്രെ', ndri :'ന്ദ്രി', ndree :'ന്ദ്രീ', ndrE :'ന്ദ്രേ', ndrai :'ന്ദ്രൈ', ndrei :'ന്ദ്രൈ', 
    ndro :'ന്ദ്രൊ', ndrO :'ന്ദ്രോ', ndrau :'ന്ദ്രൗ', ndrou :'ന്ദ്രൗ', ndraM :'ന്ദ്രം', ndraH :'ന്ദ്രഃ', 
    nd: 'ന്ദ്‌', nd2: 'ണ്ട്',
    nda: 'ന്ദ', nda2: 'ണ്ട', nda3: 'ന്ധ', nda4: 'ന്ഥ', 
    ndaa: 'ന്ദാ', ndaa2: 'ണ്ടാ', ndaa3: 'ന്ധാ', ndaa4: 'ന്ഥാ', 
    ndA: 'ന്ദാ', ndA2: 'ണ്ടാ', ndA3: 'ന്ധാ', ndA4: 'ന്ഥാ', 
    ndi: 'ന്ദി', ndi2: 'ണ്ടി', ndi3: 'ന്ധി', ndi4: 'ന്ഥി', 
    ndii: 'ന്ദീ', ndii2: 'ണ്ടീ', ndii3: 'ന്ധീ', ndii4: 'ന്ഥീ', 
    ndee: 'ന്ദീ', ndee2: 'ണ്ടീ', ndee3: 'ന്ധീ', ndee4: 'ന്ഥീ', 
    ndI: 'ന്ദീ', ndI2: 'ണ്ടീ', ndI3: 'ന്ധീ', ndI4: 'ന്ഥീ', 
    ndu: 'ന്ദു', ndu2: 'ണ്ടു', ndu3: 'ന്ധു', ndu4: 'ന്ഥു', 
    nduu: 'ന്ദൂ', nduu2: 'ണ്ടൂ', nduu3: 'ന്ധൂ', nduu4: 'ന്ഥൂ', 
    ndU: 'ന്ദൂ', ndU2: 'ണ്ടൂ', ndU3: 'ന്ധൂ', ndU4: 'ന്ഥൂ', 
    ndoo: 'ന്ദൂ', ndoo2: 'ണ്ടൂ', ndoo3: 'ന്ധൂ', ndoo4: 'ന്ഥൂ', 
    nde: 'ന്ദെ', nde2: 'ണ്ടെ', nde3: 'ന്ധെ', nde4: 'ന്ഥെ', 
    ndE: 'ന്ദേ', ndE2: 'ണ്ടേ', ndE3: 'ന്ധേ', ndE4: 'ന്ഥേ', 
    ndai: 'ന്ദൈ', ndai2: 'ണ്ടൈ', ndai3: 'ന്ധൈ', ndai4: 'ന്ഥൈ', 
    ndei: 'ന്ദൈ', ndei2: 'ണ്ടൈ', ndei3: 'ന്ധൈ', ndei4: 'ന്ഥൈ', 
    ndo: 'ന്ദൊ', ndo2: 'ണ്ടൊ', ndo3: 'ന്ധൊ', ndo4: 'ന്ഥൊ', 
    ndO: 'ന്ദോ', ndO2: 'ണ്ടോ', ndO3: 'ന്ധോ', ndO4: 'ന്ഥോ', 
    ndau: 'ന്ദൗ', ndau2: 'ണ്ടൗ', ndau3: 'ന്ധൗ', ndau4: 'ന്ഥൗ', 
    ndou: 'ന്ദൗ', ndou2: 'ണ്ടൗ', ndou3: 'ന്ധൗ', ndou4: 'ന്ഥൗ', 
    ndaM: 'ന്ദം', ndaM2: 'ണ്ടം', ndaM3: 'ന്ധം', ndaM4: 'ന്ഥം', 
    ndaH: 'ന്ദഃ', ndaH2: 'ണ്ടഃ', ndaH3: 'ന്ധഃ', ndaH4: 'ന്ഥഃ', 
    Nd: 'ണ്ഡ്', Nda: 'ണ്ഡ', Ndaa: 'ണ്ഡാ', NdA: 'ണ്ഡാ', Ndi: 'ണ്ഡി', Ndii: 'ണ്ഡീ', 
    NdI: 'ണ്ഡീ', Ndu: 'ണ്ഡു', Nduu: 'ണ്ഡൂ', Ndoo: 'ണ്ഡൂ', NdU: 'ണ്ഡൂ', Nde: 'ണ്ഡെ', 
    Nde2: 'ണ്ഡേ', NdE: 'ണ്ഡേ', Ndai: 'ണ്ഡൈ', Ndei: 'ണ്ഡൈ', 
    Ndo: 'ണ്ഡൊ', Ndo2: 'ണ്ഡോ', NdO: 'ണ്ഡോ', 
    Ndau: 'ണ്ഡൗ', NdaM: 'ണ്ഡം', NdaH: 'ണ്ഡഃ', 
    ndh: 'ന്ധ്', ndh2: 'ന്ദ്', ndha: 'ന്ധ', ndha2: 'ന്ദ',   
    ndhaa: 'ന്ധാ', ndhaa2: 'ന്ദാ', ndhi: 'ന്ധി', ndhi2: 'ന്ദി',   
    ndhii: 'ന്ധീ', ndhii2: 'ന്ദീ', ndhee: 'ന്ധീ', ndhee2: 'ന്ദീ', 
    ndhu: 'ന്ധു', ndhu2: 'ന്ദു', ndhuu: 'ന്ധൂ', ndhuu2: 'ന്ദൂ', ndhU: 'ന്ധൂ',
    ndhe: 'ന്ധെ', ndhe2: 'ന്ദെ', ndhe3: 'ന്ധേ', ndhe4: 'ന്ദേ', 
    ndhE: 'ന്ധേ', ndhE2: 'ന്ദേ', ndhai: 'ന്ധൈ', ndhai2: 'ന്ദൈ', 
    ndhei: 'ന്ധൈ', ndhei2: 'ന്ദൈ', ndho: 'ന്ധൊ', ndho2: 'ന്ദൊ', 
    ndho3: 'ന്ധോ', ndho4: 'ന്ദോ', ndhO: 'ന്ധോ', ndhO2: 'ന്ദോ',   
    ndhau: 'ന്ധൗ', ndhau2: 'ന്ദൗ', ndhaM: 'ന്ധം', ndhaM2: 'ന്ദം',   
    ndhaH: 'ന്ധഃ', ndhaH2: 'ന്ദഃ',  
    kii: 'കീ',
    kee: 'കീ',
    cee: 'സീ', cee2: 'കീ',
    kI: 'കീ',
    cI: 'കീ',
    ku: 'കു', ku2: 'കൂ',
    cu: 'കു', cu2: 'ക്യൂ', cu3: 'സു',
    kuu: 'കൂ',
    cuu: 'കൂ',
    coo: 'കൂ',
    koo: 'കൂ', koo2: 'കോ',
    kU: 'കൂ',
    cU: 'കൂ',
    kR: 'കൃ',
    cR: 'കൃ',
    ke: 'കെ', ke2: 'കേ', ke3: 'കി',
    ce: 'സി', ce2: 'സെ', ce3: 'സ്', ce4: 'സേ',
    kE: 'കേ',
    cE: 'കേ',
    kae: 'കെ', kae2: 'കേ',
    cae: 'കേ',
    kai: 'കൈ', kai2: 'കയ്',
    cai: 'കൈ',
    kei: 'കൈ', kei2: 'കെയ്',
    cei: 'കൈ',
    ko: 'കൊ', ko2: 'കോ',
    co: 'കൊ', co2: 'കോ',
    kO: 'കോ',
    cO: 'കോ',
    kau: 'കൗ',
    cau: 'കൗ',
    kou: 'കൗ',
    cou: 'കൗ',
    kaM: 'കം',
    kaH: 'കഃ',
    kh: 'ഖ്', kh2: 'ഘ്',
    kha: 'ഖ', kha2: 'ക്ക', kha3: 'ഘ',
    khaa: 'ഖാ',
    khA: 'ഖാ',
    khi: 'ഖി', khi2: 'ക്കി',
    khii: 'ഖീ',
    khee: 'ഖീ',
    khI: 'ഖീ',
    khu: 'ഖു', khu2: 'ഘു',
    khuu: 'ഖൂ', khuu2: 'ഘൂ',
    khoo: 'ഖൂ', khoo2: 'ഘൂ',
    khU: 'ഖൂ',
    khR: 'ഖൃ',
    khe: 'ഖെ', khe2: 'ഖേ',
    khE: 'ഖേ',
    khae: 'ഖേ',
    khai: 'ഖൈ',
    khei: 'ഖൈ',
    kho: 'ഖൊ', kho2: 'ഖോ',
    khO: 'ഖോ',
    khau: 'ഖൗ',
    khou: 'ഖൗ',
    khaM: 'ഖം',
    khaH: 'ഖഃ',
    K: 'ഖ്', K2: 'ഖു്', K3: 'കെ',
    Ka: 'ഖ', Ka2: 'ക', Ka3: 'ക്ക',
    Kaa: 'ഖാ',
    KA: 'ഖാ',
    Ki: 'ഖി', Ki2: 'കി',
    Kii: 'ഖീ',
    Kee: 'ഖീ', Kee2: 'കീ',
    KI: 'ഖ',
    Ku: 'ഖു', Ku2: 'കു',
    Kuu: 'ഖൂ', Kuu3: 'കൂ',
    Koo: 'ഖൂ', Koo2: 'കൂ', Koo3: 'കോ',
    KU: 'ഖൂ',
    KR: 'ഖൃ',
    Ke: 'ഖെ', Ke2: 'കെ',
    KE: 'ഖേ',
    Kae: 'ഖേ',
    Kai: 'ഖൈ',
    Kei: 'ഖൈ',
    Ko: 'ഖൊ', Ko2: 'കൊ', Ko3: 'കോ',
    KO: 'ഖോ',
    Kau: 'ഖൗ',
    Kou: 'ഖൗ',
    KaM: 'ഖം',
    KaH: 'ഖഃ',
    g: 'ഗ്', g2: 'ജി',
    ga: 'ഗ', ga2: 'ജ', ga3: 'ഖ', ga4: 'ഘ', ga5: 'ക',
    gaa: 'ഗാ',
    gA: 'ഗാ',
    gi: 'ഗി', gi2: 'ജി', gi3: 'ഖി', gi4: 'ഘി', gi5: 'കി',
    gii: 'ഗീ',
    gee: 'ഗീ',
    gI: 'ഗീ',
    gu: 'ഗു',
    guu: 'ഗൂ',
    goo: 'ഗൂ', goo2: 'ഗോ',
    gU: 'ഗൂ',
    gR: 'ഗൃ',
    ge: 'ഗെ', ge2: 'ഗേ',
    gE: 'ഗേ',
    gae: 'ഗേ',
    gai: 'ഗൈ',
    gei: 'ഗൈ',
    go: 'ഗൊ', go2: 'ഗോ',
    gO: 'ഗോ',
    gau: 'ഗൗ',
    gou: 'ഗൗ',
    gaM: 'ഗം',
    gaH: 'ഗഃ',
    gh: 'ഘ്',
    gha: 'ഘ', gha2: 'ഖ',
    ghaa: 'ഘാ',
    ghA: 'ഘാ',
    ghi: 'ഘി',
    ghii: 'ഘീ',
    ghee: 'ഘീ',
    ghI: 'ഘീ',
    ghu: 'ഘു',
    ghuu: 'ഘൂ',
    ghoo: 'ഘൂ',
    ghU: 'ഘൂ',
    ghR: 'ഘൃ',
    ghe: 'ഘെ',
    ghe2: 'ഘേ',
    ghE: 'ഘേ',
    ghae: 'ഘേ',
    ghai: 'ഘൈ',
    ghei: 'ഘൈ',
    gho: 'ഘൊ', gho2: 'ഘോ',
    ghO: 'ഘോ',
    ghau: 'ഘൗ', ghau2: 'ഗൗ',
    ghou: 'ഘൗ', ghou2: 'ഗൗ',
    ghaM: 'ഘം',
    ghaH: 'ഘഃ',
    G: 'ജി', G2: 'ഘ്', G3: 'ഗ്', G4: 'ഗ്ഗി',
    Ga: 'ഘ', Ga2: 'ഗ', Ga3: 'ഗ്ഗ', Ga4: 'ജ',
    Gaa: 'ഘാ', Gaa2: 'ഗ്ഗാ',
    GA: 'ഘാ', GA2: 'ഗ്ഗാ',
    Gi: 'ഘി', Gi2: 'ഗ്ഗി',
    Gii: 'ഘീ', Gii2: 'ഗ്ഗീ',
    Gee: 'ഘീ', Gee2: 'ഗ്ഗീ',
    GI: 'ഘീ', GI2: 'ഗ്ഗീ', GI3: 'ഗ്ഗി',
    Gu: 'ഘു', Gu2: 'ഗു', Gu3: 'ഗ്ഗു',
    Guu: 'ഘൂ', Guu2: 'ഗ്ഗൂ',
    Goo: 'ഘൂ', Goo2: 'ഗ്ഗൂ',
    GU: 'ഘൂ', GU2: 'ഗ്ഗൂ',
    GR: 'ഘൃ', GR2: 'ഗ്ഗൃ',
    Ge: 'ഘെ', Ge2: 'ഗെ', Ge3: 'ഗ്ഗെ', Ge4: 'ജെ',
    GE: 'ഘേ', GE2: 'ഗ്ഗേ',
    Gae: 'ഘേ', Gae2: 'ഗ്ഗേ',
    Gai: 'ഘൈ', Gai2: 'ഗയ്', Gai3: 'ഗെയ്', Gai4: 'ഗ്ഗൈ',
    Gei5: 'ഘൈ', Gei6: 'ഗ്ഗൈ',
    Go: 'ഘൊ', Go2: 'ഗോ', Go3: 'ഗൊ', Go4: 'ഗ്ഗൊ',
    GOO: 'ഘോ', GOO2: 'ഗ്ഗോ',
    GO: 'ഘോ',
    Gau: 'ഘൗ',
    Gou: 'ഘൗ',
    GaM: 'ഘം',
    GaH: 'ഘഃ',
    ng: 'ങ്ങ്', ng2: 'ങ്',
    Nga: 'ങ', Nga2: 'ങ്ങ',
    Ngaa: 'ങാ',
    NgA: 'ങാ',
    Ngi: 'ങി',
    Ngii: 'ങീ',
    Ngee: 'ങീ',
    Ngu: 'ങു',
    Nguu: 'ങൂ',
    Ngoo: 'ങൂ',
    NgR: 'ങൃ',
    Nge: 'ങെ',
    NgE: 'ങേ',
    Ngai: 'ങൈ',
    Ngei: 'ങൈ',
    Ngo: 'ങൊ', Ngo2: 'ങോ',
    NgO: 'ങോ',
    Ngau: 'ങൗ',
    Ngou: 'ങൗ',
    NgaH: 'ങഃ',
    nga: 'ങ്ങ', nga2: 'ങ',
    ngaa: 'ങ്ങാ', ngaa2: 'ങാ',
    ngA: 'ങ്ങാ', ngA2: 'ങാ',
    ngi: 'ങ്ങി', ngi2: 'ങി',
    ngii: 'ങ്ങീ', ngii2: 'ങീ',
    ngee: 'ങ്ങീ', ngee2: 'ങീ',
    ngI: 'ങ്ങീ', ngI2: 'ങീ',
    ngu: 'ങ്ങു', ngu2: 'ങു',
    nguu: 'ങ്ങൂ', nguu2: 'ങൂ',
    ngoo: 'ങ്ങൂ', ngoo2: 'ങൂ',
    ngU: 'ങൂ', ngU2: 'ങ്ങൂ',
    ngR: 'ങ്ങൃ', ngR2: 'ങൃ',
    nge: 'ങ്ങെ', nge2: 'ങെ',
    ngE: 'ങ്ങേ', ngE2: 'ങേ',
    ngae: 'ങ്ങേ', ngae2: 'ങേ',
    ngai: 'ങ്ങൈ', ngai2: 'ങൈ',
    nge3: 'ങ്ങൈ',
    ngei: 'ങൈ',
    ngo: 'ങ്ങൊ', ngo2: 'ങ്ങോ', ngo3: 'ങൊ', ngo4: 'ങോ',
    ngO: 'ങ്ങോ', ngO2: 'ങോ',
    ngau: 'ങ്ങൗ',
    ngou: 'ങൗ', ngou2: 'ങൗ',
    ngaM: 'ങ്ങം', ngaM2: 'ങം',
    C: 'സി',
    ch: 'ച്', ch2: 'ച്ച്', ch3: 'ക്ക്',
    cha: 'ച', cha2: 'ച്ച', cha3: 'ച്ഛ',
    cch: 'ച്ച്',
    chaa: 'ചാ',
    chA: 'ചാ',
    chi: 'ചി', chi2: 'ച്ചി', chi3: 'ചൈ',
    chii: 'ചീ',
    chee: 'ചീ', chee2: 'ച്ചീ',
    chI: 'ചീ',
    chu: 'ചു', chu2: 'ച്യു',
    chuu: 'ചൂ', chuu2: 'ച്ചൂ',
    choo: 'ചൂ', choo2: 'ച്ചൂ', choo3: 'ചോ',
    chU: 'ചൂ',
    chR: 'ചൃ',
    che: 'ചെ', che2: 'ചേ', che3: 'ച്ചെ',
    chE: 'ചേ',
    chae: 'ചേ',
    chai: 'ചൈ', chai2: 'ചായ്',
    chei: 'ചൈ',
    cho: 'ചൊ', cho2: 'ചോ',
    chO: 'ചോ',
    chau: 'ചൗ',
    chou: 'ചൗ',
    chaM: 'ചം',
    chaH: 'ചഃ',
    Ch: 'ഛ്',
    Cha: 'ഛ', Cha2: 'ച', Cha3: 'ച്ച',
    Chaa: 'ഛാ',
    ChA: 'ഛാ',
    Chi: 'ഛി', Chi2: 'ചി',
    Chii: 'ഛീ',
    Chee: 'ഛീ',
    ChI: 'ഛീ',
    Chu: 'ഛു', Chu2: 'ചു',
    Chuu: 'ഛൂ',
    Choo: 'ഛൂ',
    ChU: 'ഛൂ',
    ChR: 'ഛൃ',
    Che: 'ഛെ', Che2: 'ഛേ',
    ChE: 'ഛേ',
    Chae: 'ഛേ',
    Chai: 'ഛൈ',
    Chei: 'ഛൈ',
    Cho: 'ഛൊ', Cho2: 'ഛോ',
    ChO: 'ഛോ',
    Chau: 'ഛൗ',
    Chou: 'ഛൗ',
    ChaM: 'ഛം',
    ChaH: 'ഛഃ',
    chh: 'ഛ്',
    chha: 'ഛ', chha2: 'ച്ച',
    chhaa: 'ഛാ',
    chhA: 'ഛാ',
    chhi: 'ഛി',
    chhii: 'ഛീ',
    chhee: 'ഛീ',
    chhI: 'ഛീ',
    chhu: 'ഛു',
    chhuu: 'ഛൂ',
    chhoo: 'ഛൂ',
    chhU: 'ഛൂ',
    chhR: 'ഛൃ',
    chhe: 'ഛെ', chhe2: 'ഛേ',
    chhE: 'ഛേ',
    chhae: 'ഛേ',
    chhai: 'ഛൈ',
    chhei: 'ഛൈ',
    chho: 'ഛൊ', chho2: 'ഛോ',
    chhO: 'ഛോ',
    chhau: 'ഛൗ',
    chhou: 'ഛൗ',
    chhaM: 'ഛം',
    chhaH: 'ഛഃ',
    j: 'ജ്', j2: 'ഝ്',
    ja: 'ജ', ja2: 'ജെ',
    jaa: 'ജാ',
    jA: 'ജാ',
    ji: 'ജി', ji2: 'ജൈ',
    jii: 'ജീ',
    jee: 'ജീ',
    jI: 'ജീ',
    ju: 'ജു',
    juu: 'ജൂ',
    joo: 'ജൂ', jU: 'ജൂ', jR: 'ജൃ',
    je: 'ജെ', je2: 'ജേ', je3: 'ജീ',
    jE: 'ജേ',
    jae: 'ജേ',
    jai: 'ജൈ', jai2: 'ജയ്',
    jei: 'ജൈ',
    jo: 'ജൊ', jo2: 'ജോ',
    jO: 'ജോ',
    jau: 'ജൗ',
    jou: 'ജൗ',
    jaM: 'ജം',
    jaH: 'ജഃ',
    jh: 'ഝ്',
    jha: 'ഝ',
    jhaa: 'ഝാ',
    jhA: 'ഝാ',
    jhi: 'ഝി',
    jhii: 'ഝീ',
    jhee: 'ഝീ', jhI: 'ഝീ', jhu: 'ഝു', jhuu: 'ഝൂ', jhoo: 'ഝൂ',
    jhU: 'ഝൂ',
    jhR: 'ഝൃ',
    jhe: 'ഝെ', jhE: 'ഝേ', jhae: 'ഝേ', jhai: 'ഝൈ', jhei: 'ഝൈ', jho: 'ഝൊ', jhoo2: 'ഝോ', jhO: 'ഝോ',
    jhau: 'ഝൌ',
    jhou: 'ഝൌ',
    jhaM: 'ഝം',
    jhaH: 'ഝഃ',
    J: 'ഝ്',
    J2: 'ജെ',
    Ja: 'ഝ',
    Ja2: 'ജ',
    Ja3: 'ജെ',
    Jaa: 'ഝാ',
    JA: 'ഝാ',
    Ji: 'ഝി',
    Ji2: 'ജി',
    Ji3: 'ജൈ',
    Jii: 'ഝീ',
    Jee: 'ഝീ',
    Jee2: 'ജീ',
    JI: 'ഝീ',
    Ju: 'ഝു',
    Ju2: 'ജു',
    Juu: 'ഝൂ',
    Juu2: 'ജൂ',
    Joo: 'ഝൂ',
    Joo2: 'ജൂ',
    JU: 'ഝൂ',
    JU2: 'ജെ.യു.',
    JR: 'ഝൃ',
    JR2: 'ജെ.ആര്‍',
    Je: 'ഝെ',
    JE: 'ഝേ',
    Jae: 'ഝേ',
    Jai: 'ഝൈ',
    Jai2: 'ജയ്',
    Jei: 'ഝൈ',
    Jo: 'ഝൊ',
    Jo2: 'ജോ',
    Jo3: 'ജൊ',
    Joo3: 'ഝോ',
    JO: 'ഝോ',
    Jau: 'ഝൌ',
    Jou: 'ഝൌ',
    JaM: 'ഝം',
    JaH: 'ഝഃ',
    nj: 'ഞ്', nj2: 'ഞ്ഞ്', nj3: 'ഞ്ച്',
    nja: 'ഞ', nja2: 'ഞ്ച', nja3: 'ഞ്ഞ', nja4: 'ഞ്ജ', nja5: 'ജ്ഞ',
    njaa: 'ഞാ', njaa2: 'ഞ്ചാ', njaa3: 'ഞ്ഞാ', njaa4: 'ഞ്ജാ', njaa5: 'ജ്ഞാ',
    njA: 'ഞാ', njA2: 'ഞ്ചാ', njA3: 'ഞ്ഞാ', njA4: 'ഞ്ജാ', njA5: 'ജ്ഞാ',
    nji: 'ഞി', nji2: 'ഞ്ഞി', nji3: 'ഞ്ചി', nji4: 'ഞ്ജി', nji5: 'ജ്ഞി',
    njii: 'ഞീ', njii2: 'ഞ്ചീ', njii3: 'ഞ്ഞീ',
    njee: 'ഞീ', njee2: 'ഞ്ചീ', njee3: 'ഞ്ഞീ',
    njI: 'ഞീ',
    nju: 'ഞു',
    nju2: 'ഞ്ഞു',
    nju3: 'ഞ്ചു',
    njuu: 'ഞൂ',
    njuu2: 'ഞ്ഞൂ',
    njuu3: 'ഞ്ചൂ',
    njoo: 'ഞൂ',
    njoo4: 'ഞ്ഞൂ',
    njU: 'ഞൂ',
    njR: 'ഞൃ',
    nje: 'ഞെ',
    nje2: 'ഞ്ഞെ',
    nje3: 'ഞ്ചെ',
    njE: 'ഞേ',
    njE2: 'ഞ്ഞേ',
    njae: 'ഞേ',
    njae2: 'ഞ്ഞേ',
    njai: 'ഞൈ',
    njai2: 'ഞ്ഞൈ',
    njei: 'ഞ്ചൈ',
    njei2: 'ഞൈ',
    njei3: 'ഞ്ഞൈ',
    njo: 'ഞൊ',
    njo2: 'ഞ്ഞോ',
    njo3: 'ഞ്ചൊ',
    njO: 'ഞോ',
    njO2: 'ഞ്ഞോ',
    njO3: 'ഞ്ചോ',
    njau: 'ഞൗ',
    njau2: 'ഞ്ഞൗ',
    njou: 'ഞൗ',
    njaM: 'ഞം',
    njaH: 'ഞഃ',
    t: 'ട്', t2: 'ട്ട്', t3: 'റ്റ്', t4: 'ത്', t5: 'ടി',
    ta: 'ട',
    ta2: 'റ്റ',
    ta3: 'ത',
    ta4: 'ഠ',
    taa: 'ടാ',
    taa2: 'റ്റാ',
    taa3: 'താ',
    taa4: 'ഠാ',
    taa5: 'ട്ടാ',
    tA: 'ടാ',
    tA2: 'താ',
    tA3: 'റ്റാ',
    tA4: 'ഠാ',
    tA5: 'ട്ടാ',
    ti: 'ടി',
    ti2: 'തി',
    ti3: 'ട്ടി',
    ti4: 'റ്റി',
    ti5: 'ഠി',
    ti6: 'ടൈ',
    ti7: 'തൈ',
    tii: 'ടീ',
    tee: 'ടീ',
    tee2: 'തീ',
    tee3: 'റ്റീ',
    tea: 'ടീ',
    tea2: 'റ്റീ',
    tea3: 'തീ',
    tI: 'ടീ',
    tI2: 'റ്റീ',
    tu: 'ടു',
    tu2: 'തു',
    tu3: 'റ്റു',
    tu4: 'ട്ടു',
    tuu: 'ടൂ',
    tuu2: 'തൂ',
    tuu3: 'റ്റൂ',
    too: 'ടൂ',
    too2: 'റ്റൂ',
    too3: 'തൂ',
    tU: 'ടൂ',
    tU2: 'റ്റൂ',
    tR: 'ടൃ',
    te: 'ടെ',
    te2: 'തെ',
    te3: 'റ്റെ',
    te4: 'ഠെ',
    tE: 'ടേ',
    tE2: 'തേ',
    tae: 'ടേ',
    tai: 'ടൈ',
    tai2: 'ടായ്',
    tei: 'ടൈ',
    tei2: 'ടെയ്',
    to: 'ടൊ',
    to2: 'ടു',
    to3: 'റ്റു',
    tO: 'ടോ',
    tau: 'ടൗ',
    tou: 'ടൗ',
    taM: 'ടം',
    taM2: 'തം',
    taH: 'ടഃ',
    taH2: 'തഃ',
    T: 'ഠ്', T2: 'ട്ടു്', T3: 'ടി', T4: 'റ്റി',
    Ta: 'ഠ',
    Ta2: 'ട',
    Ta3: 'ത',
    Taa: 'ഠാ',
    TA: 'ഠാ',
    Ti: 'ഠി',
    Ti2: 'ടി',
    Ti3: 'തി',
    Ti4: 'തൈ',
    Tii: 'ഠീ',
    Tee: 'ഠീ',
    TI: 'ഠീ',
    Tu: 'ഠു',
    Tu2: 'ടു',
    Tu3: 'തു',
    Tuu: 'ഠൂ',
    Too: 'ഠൂ',
    Too2: 'ടൂ',
    Too3: 'തൂ',
    TU: 'ഠൂ',
    TR: 'ഠൃ',
    Te: 'ഠെ',
    Te2: 'ടെ',
    Te3: 'തെ',
    TE: 'ഠേ',
    TE2: 'ടേ',
    Tae: 'ഠേ',
    Tai: 'ഠൈ',
    Tei: 'ഠൈ',
    To: 'ഠൊ',
    To2: 'ടു',
    To3: 'തൊ',
    TO: 'ഠോ',
    TO2: 'തോ',
    Tau: 'ഠൗ',
    Tou: 'ഠൗ',
    TaM: 'ഠം',
    TaH: 'ഠഃ',
    D: 'ഡ്',
    D2: 'ദ്',
    D3: 'ഡി',
    Da: 'ഡ',
    Da2: 'ദ',
    Da3: 'ഢ',
    Da4: 'ഠ',
    Daa: 'ഡാ',
    Daa2: 'ദാ',
    DA: 'ഡാ',
    DA3: 'ദാ',
    Di: 'ഡി',
    Dii: 'ഡീ',
    Dee: 'ഡീ',
    DI: 'ഡീ',
    Du: 'ഡു',
    Du2: 'ദു',
    Du3: 'ദുഃ',
    Duu: 'ഡൂ',
    Doo: 'ഡൂ',
    DU: 'ഡൂ',
    DR: 'ഡൃ',
    De: 'ഡെ',
    De2: 'ടെ',
    DE: 'ഡേ',
    Dae: 'ഡേ',
    Dai: 'ഡൈ',
    Dei: 'ഡൈ',
    Do: 'ഡൊ',
    Do2: 'ദൊ',
    DO: 'ഡോ',
    Dau: 'ഡൌ',
    Dou: 'ഡൌ',
    DaM: 'ഡം',
    DaH: 'ഡഃ',
    Dh: 'ഢ്',
    Dha: 'ഢ',
    Dhaa: 'ഢാ',
    DhA: 'ഢാ',
    Dhi: 'ഢി',
    Dhii: 'ഢീ',
    Dhee: 'ഢീ',
    DhI: 'ഢീ',
    Dhu: 'ഢു',
    Dhuu: 'ഢൂ',
    Dhoo: 'ഢൂ',
    DhU: 'ഢൂ',
    DhR: 'ഢൃ',
    Dhe: 'ഢെ',
    DhE: 'ഢേ',
    Dhae: 'ഢേ',
    Dhai: 'ഢൈ',
    Dhei: 'ഢൈ',
    Dho: 'ഢൊ',
    DhO: 'ഢോ',
    Dhau: 'ഢൌ',
    Dhau2: 'ഢൌ',
    Dhou: 'ഢൌ',
    DhaM: 'ഢം',
    DhaH: 'ഢഃ',
    N: 'ൺ', N2: 'ണ്', N3: 'ൻ', N4: 'ണ്ണ്', N5: 'എൻ',
    'N_': 'ൺ',
    'N~': 'ൺ',
    Na: 'ണ',
    Na2: 'ന',
    Na3: 'നാ',
    Na4: 'ണ്ണ',
    Naa: 'ണാ',
    Naa2: 'നാ',
    NA: 'ണാ',
    Ni: 'ണി',
    Ni2: 'ണ്ണി',
    Nii: 'ണീ',
    Nee: 'ണീ',
    Nee2: 'നീ',
    NI: 'ണീ',
    Nu: 'ണു',
    Nuu: 'ണൂ',
    Nuu2: 'നൂ',
    Noo: 'ണൂ',
    Noo2: 'നൂ',
    NU: 'ണൂ',
    NR: 'ണൃ',
    Ne: 'ണെ',
    NE: 'ണേ',
    NE2: 'നീ',
    NE3: 'ണേ',
    Nae: 'ണേ',
    Nai: 'ണൈ',
    Nei: 'ണൈ',
    No: 'ണൊ',
    No2: 'നോ',
    NO: 'ണോ',
    NO2: 'നോ',
    Nau: 'ണൗ',
    Nou: 'ണൗ',
    NaM: 'ണം',
    NaH: 'ണഃ',
    Ny: 'ണ്യ്', Nya: 'ണ്യ', Nyaa: 'ണ്യാ', Nyi: 'ണ്യി', 
    Nyii: 'ണ്യീ', Nyu: 'ണ്യു', Nyuu: 'ണ്യൂ', Nye: 'ണ്യെ', 
    Nye2: 'ണ്യേ', Nyo: 'ണ്യൊ', Nyo2: 'ണ്യോ', Nyai: 'ണ്യൈ', 
    NyaM: 'ണ്യം', NyaH: 'ണ്യഃ',
    ny: 'ന്യ്', nya: 'ന്യ', nyaa: 'ന്യാ', nyi: 'ന്യി', nyii: 'ന്യീ', 
    nyu: 'ന്യു', nyuu: 'ന്യൂ', nye: 'ന്യെ', nye2: 'ന്യേ', nyai: 'ന്യൈ',
    nyo: 'ന്യൊ', nyo2: 'ന്യോ', nyaM: 'ന്യം', nyaH: 'ന്യഃ',
    nyi2: 'ന്‍യി',
    th: 'ത്',
    th2: 'ഥ്',
    th3: 'ത്ത്',
    th4: 'ത്തു്',
    tha: 'ത',
    tha2: 'ധ',
    tha3: 'ഥ',
    tha4: 'ത്ത',
    tha5: 'ദ്ധ',
    thaa: 'താ',
    thaa2: 'ഥാ',
    thaa3: 'ധാ',
    thaa4: 'ത്താ',
    thA: 'താ',
    thA2: 'ഥാ',
    thA3: 'ധാ',
    thA4: 'ത്താ',
    thi: 'തി',
    thi2: 'ത്തി',
    thi3: 'ഥി',
    thi4: 'ധി',
    thi5: 'ത്ഥി',
    thi6: 'ദ്ധി',
    thi7: 'തൈ',
    thii: 'തീ',
    thii2: 'ത്തീ',
    thii3: 'ഥീ',
    thii4: 'ധീ',
    thee: 'തീ',
    thee2: 'ഥീ',
    thI: 'തീ',
    thu: 'തു',
    thu2: 'ത്തു',
    thuu: 'തൂ',
    thuu2: 'ഥൂ',
    thoo: 'തൂ',
    thoo2: 'ഥൂ',
    thoo3: 'തോ',
    thU: 'തൂ',
    thR: 'തൃ',
    the: 'തെ', the2: 'തേ',
    thE: 'തേ',
    thae: 'തേ',
    thee3: 'തേ',
    thai: 'തൈ',
    thei: 'തൈ',
    thei2: 'തെയ്',
    tho: 'തൊ', tho2: 'തോ', tho3: 'ത്തൊ', tho4: 'ത്തോ',
    thO: 'തോ', thO2: 'ത്തോ',
    thau: 'തൗ',
    thou: 'തൗ',
    thaM: 'തം', thaM2: 'ത്തം',
    thaH: 'തഃ',
    Th: 'ഥ്',
    Th2: 'ഥു്',
    Tha: 'ഥ',
    Tha2: 'ത',
    Thaa: 'ഥാ',
    Thaa2: 'താ',
    ThA: 'ഥാ',
    Thi: 'ഥി',
    Thi2: 'തി',
    Thi3: 'ത്ഥി',
    Thii: 'ഥീ',
    Thee: 'ഥീ',
    Thee2: 'തീ',
    ThI: 'ഥീ',
    Thu: 'ഥു',
    Thu2: 'തു',
    Thuu: 'ഥൂ',
    Thuu2: 'തൂ',
    Thoo: 'ഥൂ',
    Thoo2: 'തൂ',
    ThU: 'ഥൂ',
    ThU2: 'തൂ',
    ThR: 'ഥൃ',
    ThR2: 'തൃ',
    The: 'ഥെ',
    The2: 'ദി',
    The3: 'തെ',
    ThE: 'ഥേ',
    Thae: 'ഥേ',
    Thai: 'ഥൈ',
    Thai2: 'തൈ',
    Thei: 'ഥൈ',
    Thei2: 'തെയ്',
    Tho: 'ഥൊ',
    ThO: 'ഥോ',
    Thau: 'ഥൗ',
    Thou: 'ഥൗ',
    ThaM: 'ഥം',
    ThaH: 'ഥഃ',
    TH: 'ഥ്',
    TH2: 'ഥു്',
    THa: 'ഥ',
    THa2: 'ത',
    THaa: 'ഥാ',
    THaa2: 'താ',
    THA: 'ഥാ',
    THi: 'ഥി',
    THi2: 'തി',
    THi3: 'ത്ഥി',
    THii: 'ഥീ',
    THee: 'ഥീ',
    THee2: 'തീ',
    THI: 'ഥീ',
    THu: 'ഥു',
    THu2: 'തു',
    THuu: 'ഥൂ',
    THuu2: 'തൂ',
    THoo: 'ഥൂ',
    THoo2: 'തൂ',
    THU: 'ഥൂ',
    THU2: 'തൂ',
    THR: 'ഥൃ',
    THR2: 'തൃ',
    THe: 'ഥെ',
    THe2: 'ദി',
    THe3: 'തെ',
    THE: 'ഥേ',
    THae: 'ഥേ',
    THai: 'ഥൈ',
    THai2: 'തൈ',
    THei: 'ഥൈ',
    THei3: 'തെയ്',
    THo: 'ഥൊ',
    THO: 'ഥോ',
    THau: 'ഥൗ',
    THou: 'ഥൗ',
    THaM: 'ഥം',
    THaH: 'ഥഃ',
    tH: 'ഥ്',
    tH2: 'ഥു്',
    tHa: 'ഠ',
    tHa2: 'ത',
    tHaa: 'ഠാ',
    tHaa2: 'താ',
    tHA: 'ഠാ',
    tHi: 'ഠി',
    tHi2: 'തി',
    tHi3: 'ത്ഠി',
    tHii: 'ഠീ',
    tHee: 'ഠീ',
    tHee2: 'തീ',
    tHI: 'ഠീ',
    tHu: 'ഥു',
    tHu2: 'തു',
    tHuu: 'ഥൂ',
    tHuu2: 'തൂ',
    tHoo: 'ഥൂ',
    tHoo2: 'തൂ',
    tHU: 'ഥൂ',
    tHU2: 'തൂ',
    tHR: 'ഥൃ',
    tHR2: 'തൃ',
    tHe: 'ഠെ',
    tHe2: 'ദി',
    tHe3: 'തെ',
    tHE: 'ഠേ',
    tHae: 'ഠേ',
    tHai: 'ഠൈ',
    tHai2: 'തൈ',
    tHei: 'ഠൈ',
    tHei2: 'തെയ്',
    tHo: 'ഠൊ',
    tHO: 'ഠോ',
    tHau: 'ഠൗ',
    tHou: 'ഠൗ',
    tHaM: 'ഠം',
    tHaH: 'ഠഃ',
    d: 'ദ്', d2: 'ട്', d3: 'ഡി', d4: 'ദ്ദ്',
    da: 'ദ', da2: 'ട', da3: 'ഡ',
    daa: 'ദാ', daa2: 'ടാ',
    dA: 'ദാ', dA2: 'ടാ',
    di: 'ദി', di2: 'ടി', di3: 'ധി', di4: 'ഥി', di5: 'ഡൈ',
    dii: 'ദീ', dii2: 'ടീ',
    dee: 'ദീ', dee2: 'ടീ',
    dI: 'ദീ', dI2: 'ടീ',
    du: 'ദു', du2: 'ടു', du3: 'ദുഃ', du4: 'തു',
    duu: 'ദൂ',
    doo: 'ദൂ',
    dU: 'ദൂ',
    dR: 'ദൃ',
    de: 'ദെ', de2: 'ടെ', de3: 'തെ',
    dE: 'ദേ',
    dE2: 'തേ',
    dae: 'ദേ',
    dai: 'ദൈ', dai2: 'ഡായ്',
    dei: 'ദൈ', dei2: 'ഡേയ്',
    'do': 'ദൊ',
    dO: 'ദോ',
    dau: 'ദൗ',
    dou: 'ദൗ',
    daM: 'ദം',
    daH: 'ദഃ',
    dh: 'ധ്', dh2: 'ദ്',
    dha: 'ധ',
    dhaa: 'ധാ',
    dhA: 'ധാ',
    dhi: 'ധി',
    dhii: 'ധീ',
    dhee: 'ധീ',
    dhI: 'ധീ',
    dhu: 'ധു',
    dhuu: 'ധൂ',
    dhoo: 'ധൂ',
    dhU: 'ധൂ',
    dhR: 'ധൃ',
    dhe: 'ധെ',
    dhE: 'ധേ',
    dhae: 'ധേ',
    dhai: 'ധൈ',
    dhei: 'ധൈ',
    dho: 'ധൊ',
    dhO: 'ധോ',
    dhau: 'ധൗ',
    dhou: 'ധൗ',
    dhaM: 'ധം',
    dhaH: 'ധഃ',
    n: 'ൻ', n2: 'ന്', n3: 'ൺ', n4: 'ണ്', n5: 'എൻ',    
    'n_': 'ൻ',
    'n~': 'ൻ',
    na: 'ന', na2: 'ണ', 
    naa: 'നാ', naa2: 'ണാ',
    nA: 'നാ',
    ni: 'നി', ni2: 'ണി', ni3: 'നൈ',
    nii: 'നീ', nii2: 'ണീ',
    nee: 'നീ', nee2: 'നേ',
    nI: 'നീ', nI2: 'ണീ',
    nu: 'നു', nu2: 'ണു', nu3: 'ന്', nu4: 'ണ്',
    nm:'ന്മ്', nma:'ന്മ', nmaa:'ന്മാ', nmi:'ന്മി', nmii:'ന്മീ', nmee:'ന്മീ', 
    nmu:'ന്മു', nmuu:'ന്മൂ', nmoo:'ന്മൂ', nmU:'ന്മൂ', nme:'ന്മെ', nme2:'ന്മേ', nmE:'ന്മേ', 
    nmai:'ന്മൈ', nmei:'ന്മൈ', nmo:'ന്മൊ', nmo2:'ന്മോ', nmO:'ന്മോ', 
    nmau:'ന്മൗ', nmaM:'ന്മം', nmaH:'ന്മഃ', 
    Nm: 'ണ്മ്', Nma: 'ണ്മ', Nmaa: 'ണ്മാ', Nmi: 'ണ്മി', Nmii: 'ണ്മീ', Nmee: 'ണ്മീ',
    Nmu: 'ണ്മു', Nmuu: 'ണ്മൂ', NmU: 'ണ്മൂ', Nmoo: 'ണ്മൂ', Nme: 'ണ്മെ', Nme2: 'ണ്മേ', NmE: 'ണ്മേ', 
    Nmai: 'ണ്മൈ', Nmei: 'ണ്മൈ', Nmo: 'ണ്മൊ', Nmo2: 'ണ്മോ', 
    NmO: 'ണ്മോ', Nmau: 'ണ്മൗ', NmaM: 'ണ്മം', NmaH: 'ണ്മഃ',
    nn: 'ന്ന്', nn2: 'ണ്ണ്', nn3: 'ൺ',
    nna: 'ന്ന', nna2: 'ണ്ണ',
    nnaa:'ന്നാ', nnaa2:'ണ്ണാ',
    nnu: 'ന്നു', nnu2: 'ണ്ണു',
    nni: 'ന്നി', nni2: 'ണ്ണി',
    nnuu: 'ന്നൂ', nnuu2: 'ണ്ണൂ', nnU: 'ന്നൂ',
    nnoo: 'ന്നൂ', nnoo2: 'ണ്ണൂ',
    nne: 'ന്നെ', nne2: 'ണ്ണെ', nne3: 'ന്നേ', nne4: 'ണ്ണേ',
    nnE: 'ന്നേ', nnE2: 'ണ്ണേ', nnE3: 'ന്നെ', nnE4: 'ണ്ണെ', 
    nnae: 'ന്നേ', nnae2: 'ണ്ണേ',
    nnee: 'ന്നീ', nnee2: 'ണ്ണീ', nnee3: 'ന്നേ',
    nnii: 'ന്നീ', nnii2: 'ണ്ണീ',
    nnai: 'ന്നൈ', nnai2: 'ണ്ണൈ',
    nno:'ന്നൊ', nno2:'ന്നോ', nno3:'ണ്ണൊ', nno4:'ണ്ണോ',
    Nn:'ണ്ണ്', Nna:'ണ്ണ',Nnaa:'ണ്ണാ', Nni:'ണ്ണി', Nnii:'ണ്ണീ', Nnee:'ണ്ണീ', Nnu:'ണ്ണു',
    Nnuu:'ണ്ണൂ', Nnoo:'ണ്ണൂ', NnU:'ണ്ണൂ', Nne:'ണ്ണെ', Nne2:'ണ്ണേ', NnE:'ണ്ണേ', 
    Nnai:'ണ്ണൈ', Nnei:'ണ്ണൈ', Nno:'ണ്ണൊ', Nno2:'ണ്ണോ', NnO:'ണ്ണോ',
    Nnau:'ണ്ണൗ', NnaM:'ണ്ണം', NnaH:'ണ്ണഃ',
    NN:'ണ്ണ്', NNa:'ണ്ണ',NNaa:'ണ്ണാ', NNi:'ണ്ണി', NNii:'ണ്ണീ', NNee:'ണ്ണീ', NNu:'ണ്ണു',
    NNuu:'ണ്ണൂ', NNoo:'ണ്ണൂ', NNU:'ണ്ണൂ', NNe:'ണ്ണെ', NNe2:'ണ്ണേ', NNE:'ണ്ണേ', 
    NNai:'ണ്ണൈ', NNei:'ണ്ണൈ', NNo:'ണ്ണൊ', NNo2:'ണ്ണോ', NNO:'ണ്ണോ',
    NNau:'ണ്ണൗ', NNaM:'ണ്ണം', NNaH:'ണ്ണഃ',
    nuu: 'നൂ', nuu2: 'ണൂ',
    nv: 'ന്വ്', nv2: 'ൻവ്', nv3:'ണ്വ്', nv4:'ൺവ്', nw: 'ന്വ്', nw2: 'ൻവ്', nw3: 'ണ്വ്', nw4: 'ൺവ്', nva: 'ന്വ', nva2: 'ൻവ', nva3: 'ണ്വ', nva4: 'ൺവ', nwa: 'ന്വ', nwa2: 'ൻവ', nwa3: 'ണ്വ', nwa4: 'ൺവ',
    noo: 'നൂ', noo2: 'ണൂ',
    nU: 'നൂ', nU2: 'ണൂ',
    nR: 'നൃ',
    ne: 'നെ', ne2: 'ണെ', ne3: 'നേ', ne4: 'ണേ',
    nE: 'നേ', nE2: 'ണേ', nE3: 'നെ', nE4: 'ണെ', 
    nae: 'നേ',
    nai: 'നൈ', nai2: 'നായ്',
    nei: 'നെയ്', nei2: 'നൈ',
    no: 'നൊ', no2: 'നോ', no3: 'ണൊ', no4: 'ണോ',
    nO: 'നോ', nO2: 'ണോ',
    nau: 'നൗ',
    nou: 'നൗ',
    naM: 'നം',
    naH: 'നഃ',
    p: 'പ്', p2: 'പു്', p3: 'പ്പ്', p4: 'പ്പു്', p5: 'പി',
    pa: 'പ', Pa2: 'പ',
    paa: 'പാ',
    pA: 'പാ',
    pi: 'പി', pi2: 'പൈ', pi3: 'പ്പി',
    Pi: 'പി',
    pii: 'പീ',
    pee: 'പീ', pee2: 'പേ',
    Pee: 'പീ',
    pI: 'പീ',
    pu: 'പു',
    Pu: 'പു',
    puu: 'പൂ',
    poo: 'പൂ',
    poo2: 'പോ',
    Poo: 'പൂ',
    pU: 'പൂ',
    pR: 'പൃ',
    pe: 'പെ', pe2: 'പേ', pe3: 'പി',
    pE: 'പേ',
    pae: 'പേ',
    pai: 'പൈ',
    pai2: 'പയ്',
    pai3: 'പായ്',
    pei: 'പെയ്',
    pei2: 'പൈ',
    po: 'പൊ',
    pO: 'പോ',
    pau: 'പൗ',
    pou: 'പൗ',
    paM: 'പം',
    paH: 'പഃ',
    P: 'പ്',
    P2: 'പ്പ്',
    P3: 'പ്പു്',
    P4: 'പി',
    Pa: 'പ',
    Paa: 'പാ',
    PA: 'പാ',
    Pi2: 'പി',
    Pi3: 'പ്പി',
    Pi4: 'പി',
    Pi5: 'പൈ',
    Pii: 'പീ',
    Pee2: 'പീ',
    Pee3: 'പേ',
    PI: 'പീ',
    Pu2: 'പു',
    Puu: 'പൂ',
    Poo2: 'പൂ',
    Poo3: 'പോ',
    PU: 'പൂ',
    PR: 'പൃ',
    Pe: 'പെ',
    Pe2: 'പി',
    PE: 'പേ',
    Pae: 'പേ',
    Pai: 'പൈ',
    Pai2: 'പയ്',
    Pai3: 'പായ്',
    Pei: 'പെയ്',
    Pei2: 'പൈ',
    Po: 'പൊ',
    PO: 'പോ',
    Pau: 'പൗ',
    Pou: 'പൗ',
    PaM: 'പം',
    PaH: 'പഃ',
    f: 'ഫ്',
    f2: 'എഫ്',
    fa: 'ഫ',
    faa: 'ഫാ',
    fA: 'ഫാ',
    fi: 'ഫി',
    fii: 'ഫീ',
    fee: 'ഫീ',
    fI: 'ഫീ',
    fu: 'ഫു',
    fuu: 'ഫൂ',
    foo: 'ഫൂ',
    fU: 'ഫൂ',
    fR: 'ഫൃ',
    fe: 'ഫെ',
    fE: 'ഫേ',
    fai: 'ഫൈ',
    fei: 'ഫൈ',
    fo: 'ഫൊ',
    fO: 'ഫോ',
    fau: 'ഫൗ',
    fou: 'ഫൗ',
    faM: 'ഫം',
    faH: 'ഫഃ',
    F: 'ഫ്',
    F2: 'എഫ്',
    Fa: 'ഫ',
    Faa: 'ഫാ',
    FA: 'ഫാ',
    Fi: 'ഫി',
    Fii: 'ഫീ',
    Fee: 'ഫീ',
    FI: 'ഫീ',
    Fu: 'ഫു',
    Fuu: 'ഫൂ',
    Foo: 'ഫൂ',
    FU: 'ഫൂ',
    FR: 'ഫൃ',
    Fe: 'ഫെ',
    FE: 'ഫേ',
    Fai: 'ഫൈ',
    Fei: 'ഫൈ',
    Fo: 'ഫൊ',
    FO: 'ഫോ',
    Fau: 'ഫൗ',
    Fou: 'ഫൗ',
    FaM: 'ഫം',
    FaH: 'ഫഃ',
    ph: 'ഫ്',
    ph2: 'പി.എച്.',
    pha: 'ഫ',
    phaa: 'ഫാ',
    phA: 'ഫാ',
    phi: 'ഫി',
    phii: 'ഫീ',
    phee: 'ഫീ',
    phI: 'ഫീ',
    phu: 'ഫു',
    phuu: 'ഫൂ',
    phoo: 'ഫൂ',
    phU: 'ഫൂ',
    phR: 'ഫൃ',
    phe: 'ഫെ',
    phE: 'ഫേ',
    phai: 'ഫൈ',
    phei: 'ഫൈ',
    pho: 'ഫൊ',
    pho2: 'ഫോ',
    phO: 'ഫോ',
    phau: 'ഫൗ',
    phou: 'ഫൗ',
    phaM: 'ഫം',
    phaH: 'ഫഃ',
    b: 'ബ്',
    b2: 'ബ്ബ്',
    b3: 'ബി',
    ba: 'ബ', ba2: 'ബാ', ba3: 'ബൈ', ba4: 'ബേ',
    baa: 'ബാ',
    bA: 'ബാ',
    bi: 'ബി',
    bi2: 'ബൈ',
    bii: 'ബീ',
    bee: 'ബീ',
    bI: 'ബീ',
    bu: 'ബു',
    buu: 'ബൂ',
    boo: 'ബൂ',
    boo2: 'ബോ',
    bU: 'ബൂ',
    bR: 'ബൃ',
    be: 'ബെ', be2: 'ബേ',
    bE: 'ബേ',
    bae: 'ബേ',
    bai: 'ബൈ',
    bai2: 'ബായ്',
    bei: 'ബൈ',
    bo: 'ബൊ',
    bO: 'ബോ',
    bau: 'ബൗ',
    bau3: 'ഭൗ',
    bou: 'ബൗ',
    baM: 'ബം',
    baH: 'ബഃ',
    bh: 'ഭ്',
    bha: 'ഭ',
    bhaa: 'ഭാ',
    bhA: 'ഭാ',
    bhi: 'ഭി',
    bhii: 'ഭീ',
    bhee: 'ഭീ',
    bhI: 'ഭീ',
    bhu: 'ഭു',
    bhuu: 'ഭൂ',
    bhoo: 'ഭൂ',
    bhU: 'ഭൂ',
    bhR: 'ഭൃ',
    bhe: 'ഭെ',
    bhE: 'ഭേ',
    bhae: 'ഭേ',
    bhai: 'ഭൈ',
    bhai2: 'ഭായ്',
    bhei: 'ഭൈ',
    bho: 'ഭൊ',
    bhO: 'ഭോ',
    bhau: 'ഭൗ',
    bhou: 'ഭൗ',
    bhaM: 'ഭം',
    bhaH: 'ഭഃ',
    B: 'ഭ്',
    B2: 'ബ്',
    B3: 'ബി',
    Ba: 'ഭ',
    Ba2: 'ബ',
    Ba3: 'ബാ',
    Baa: 'ഭാ',
    Baa2: 'ബാ',
    BA: 'ഭാ',
    BA2: 'ബി.എ.',
    Bi: 'ഭി',
    Bi2: 'ബൈ',
    Bii: 'ഭീ',
    Bee: 'ഭീ',
    BI: 'ഭീ',
    Bu: 'ഭു',
    Bu2: 'ബു',
    Buu: 'ഭൂ',
    Boo: 'ഭൂ',
    BU: 'ഭൂ',
    BR: 'ഭൃ',
    Be: 'ഭെ',
    BE: 'ഭേ',
    Bai: 'ഭൈ',
    Bei: 'ഭൈ',
    Bo: 'ഭൊ',
    Bo2: 'ബോ',
    BO: 'ഭോ',
    Bau: 'ഭൗ',
    Bou: 'ഭൗ',
    BaM: 'ഭം',
    BaH: 'ഭഃ',
    m: 'മ്',
    m2: 'ം',
    'm ': 'ം ',
    'm 2': 'മ്',
    m3: 'എം',
    m_: 'ം',
    'm~': 'ം',
    ma: 'മ',
    ma2: 'മ്മ',
    maa: 'മാ',
    // mA: 'മാ',
    mi: 'മി',
    mii: 'മീ',
    mee: 'മീ',
    mI: 'മീ',
    mu: 'മു',
    muu: 'മൂ',
    moo: 'മൂ',
    moo2: 'മോ',
    mU: 'മൂ',
    mR: 'മൃ',
    me: 'മെ', me2: 'മേ',
    mE: 'മേ',
    mae: 'മേ',
    mai: 'മൈ',
    mai2: 'മയ്',
    mei: 'മെയ്',
    mei2: 'മൈ',
    mo: 'മൊ', mo2: 'മോ',
    mO: 'മോ',
    mau: 'മൗ',
    mou: 'മൗ',
    maM: 'മം',
    maH: 'മഃ',
    M: 'മ്',
    M2: 'ം',
    M3: 'എം',
    M_: 'ം',
    'M~': 'ം',
    Ma: 'മ',
    Ma2: 'മ്മ',
    Maa: 'മാ',
    MA: 'മാ',
    Mi: 'മി',
    Mii: 'മീ',
    Mee: 'മീ',
    MI: 'മീ',
    Mu: 'മു',
    Muu: 'മൂ',
    Moo: 'മൂ',
    Moo2: 'മോ',
    MU: 'മൂ',
    MR: 'മൃ',
    Me: 'മെ', Me2: 'മേ',
    ME: 'മേ',
    Mae: 'മേ',
    Mai: 'മൈ',
    Mai2: 'മയ്',
    Mei: 'മെയ്',
    Mei2: 'മൈ',
    Mo: 'മൊ', Mo2: 'മോ',
    MO: 'മോ',
    Mau: 'മൗ',
    Mou: 'മൗ',
    MaM: 'മം',
    MaH: 'മഃ',
    np: 'ന്‍പ്',
    npa: 'ന്‍പ', npa2: 'മ്പ',
    npi: 'ൻപി', npi2: 'മ്പി',
    npe: 'ൻപെ', npe2: 'ൻപേ', npe3: 'മ്പെ', npe4: 'മ്പേ',
    npE: 'ൻപേ', npE2: 'മ്പേ',
    mb: 'മ്പ്',
    mba: 'മ്പ', mba2: 'മ്പാ', mbA: 'മ്പാ', mbaa: 'മ്പാ', 
    mbu: 'മ്പു', mbu2: 'മ്പൂ', mbU: 'മ്പൂ',
    mbi: 'മ്പി', mbi2: 'മ്പീ', mbai: 'മ്പൈ',
    mbe: 'മ്പെ', mbe2: 'മ്പേ', mbe3: 'മ്പീ', 
    mbo:'മ്പൊ', mbo2:'മ്പോ', mbO:'മ്പോ',
    mbE: 'മ്പേ',
    mp: 'മ്പ്',
    mpa: 'മ്പ', mpa2: 'മ്പാ',  mpA: 'മ്പാ', mpaa: 'മ്പാ', 
    mpu: 'മ്പു', mpu2: 'മ്പൂ', mpU: 'മ്പൂ',
    mpi: 'മ്പി', mpi2: 'മ്പീ', mpai: 'മ്പൈ',
    mpe: 'മ്പെ', mpe2: 'മ്പേ', mpe3: 'മ്പീ', 
    mpo:'മ്പൊ', mpo2:'മ്പോ', mpO:'മ്പോ',
    mpE: 'മ്പേ',
    y: 'യ്', y2: 'യു', y3: 'യ്യ്', y4: 'യ്യു', y5: 'വൈ',
    ya: 'യ',
    yaa: 'യാ',
    yA: 'യാ',
    yi: 'യി', yi2: 'യീ',
    yii: 'യീ',
    yee: 'യീ',
    yI: 'യീ',
    yu: 'യു', yu2: 'യൂ',
    yuu: 'യൂ',
    yoo: 'യൂ',
    yU: 'യൂ',
    yR: 'യൃ',
    ye: 'യെ', ye2: 'യേ',
    yE: 'യേ',
    yae: 'യേ',
    yai: 'യൈ',
    yei: 'യൈ',
    yo: 'യൊ', yo2: 'യോ',
    yO: 'യോ',
    yau: 'യൗ',
    you: 'യൗ', you2: 'യു', you3: 'യൂ',
    yaM: 'യം',
    yaH: 'യഃ',
    Ya: 'യ',
    Yaa: 'യാ',
    YA: 'യാ',
    Yi: 'യി',
    Yii: 'യീ',
    Yee: 'യീ',
    YI: 'യീ',
    Yu: 'യു',
    Yuu: 'യൂ',
    Yoo: 'യൂ',
    YU: 'യൂ',
    YR: 'യൃ',
    Ye: 'യെ',
    Ye2: 'യേ',
    YE: 'യേ',
    Yai: 'യൈ',
    Yei: 'യൈ',
    Yo: 'യൊ', Yo2: 'യോ',
    YO: 'യോ',
    Yau: 'യൗ',
    yaM2: 'യം',
    r: 'ർ', r2: 'ര്', r3: 'റ്', r4: 'ആർ',
    r_: 'ർ',
    'r~': 'ർ',
    ra: 'ര', ra2: 'റ',
    raa: 'രാ', raa2: 'റാ',
    rA: 'രാ', rA2: 'റാ',
    ri: 'രി', ri2: 'റി', ri3: 'രൈ', ri4: 'റൈ', ri5: 'ഋ',
    rii: 'രീ', rii2: 'റീ',
    ree: 'രീ', ree2: 'റീ',
    rI: 'രീ',
    ru: 'രു', ru2: 'റു',
    rv: 'ർവ്', rv2: 'ര്വ്', rv3:'റ്വ്', rw: 'ർവ്', rw2: 'ര്വ്', rw3: 'റ്വ്', rva: 'ർവ', rva2: 'ര്വ', rva3: 'റ്വ', rwa: 'ർവ', rwa2: 'ര്വ', rwa3: 'റ്വ',
    rve: 'ർവെ', rve2: 'ർവേ', rve3: 'ര്വെ', rve4:'ര്വേ',
    rvE: 'ർവേ', rvE2: 'ർവെ', rvE3:'ര്വേ', rvE4: 'ര്വെ',
    rvi: 'ർവി', rvi2: 'ർവീ', rvee: 'ർവീ', rvii: 'ർവീ',
    rvai: 'ർവൈ', rvai2: 'ര്വൈ', 
    ruu: 'രൂ',
    roo: 'രൂ',
    rU: 'രൂ',
    rR: 'രൃ',
    re: 'രെ', re2: 'രേ', re3: 'റെ', re4: 'റേ', re5: 'രി', re6: 'റി',
    rE: 'രേ',
    rae: 'രേ',
    rai: 'രൈ', rai2: 'രായ്',
    rei: 'രൈ', rei2: 'രെയ്',
    ro: 'രൊ', ro2: 'രോ', ro3: 'റൊ', ro4: 'റോ',
    rO: 'രോ',
    rau: 'രൗ', rau2: 'റൗ',
    rou: 'രൗ', rou2: 'റൗ',
    raM: 'രം',
    raH: 'രഃ',
    ry: 'ര്യ്', rya: 'ര്യ', ryaa: 'ര്യാ', ryo: 'ര്യോ', ryo2: 'ര്യോ', ryO: 'ര്യോ',
    rye: 'ര്യെ', rye2: 'ര്യേ', ryE: '', ryee: 'ര്യീ', ryi: 'ര്യി', ryoo: 'ര്യൂ',
    ryoo2: 'റ്യൂ', ryu: 'ര്യു', ryoo3: 'ര്‍യൂ', 
    R: 'ർ', R2: 'റ്', R3: 'ര്', R4: 'ആർ', R5: 'റ്\u200D',
    'R~': 'ർ',
    R_: 'ർ',
    Ra: 'റ', Ra2: 'ര', Ra3: 'രാ',
    Raa: 'റാ',
    RA: 'റാ',
    Ri: 'റി', Ri2: 'രി',
    Rii: 'റീ',
    Ree: 'റീ', Ree2: 'രീ',
    RI: 'റീ',
    Ru: 'റു', Ru2: 'രു',
    Ruu: 'റൂ', Ruu2: 'രൂ',
    Roo: 'റൂ', Roo2: 'രൂ',
    RU: 'റൂ',
    Re: 'റെ', Re2: 'റേ',
    RE: 'റേ',
    Rae: 'റേ',
    Rai: 'റൈ', Rai2: 'റായ്',
    Rei: 'റൈ', Rei2: 'റെയ്',
    Ro: 'റൊ', Ro2: 'റോ',
    RO: 'റോ',
    Rau: 'റൗ',
    Rou: 'റൗ',
    RaM: 'റം',
    RaH: 'റഃ',
    l: 'ൽ', l2: 'ൾ', l3: 'ള്', l4: 'ല്', l5: 'എൽ',
    ll: 'ല്ല്', ll2: 'ള്ള്', 
    lla: 'ല്ല', lla2: 'ള്ള', 
    llaa: 'ല്ലാ', llaa2: 'ള്ളാ', 
    lli: 'ല്ലി', lli2: 'ള്ളി', 
    lle: 'ല്ലെ', lle2: 'ള്ളെ', lle3: 'ല്ലേ', lle4: 'ള്ളേ', 
    llee: 'ല്ലീ', llee2: 'ള്ളീ', llee3: 'ള്ളേ', llee4: 'ല്ലേ', 
    llii: 'ല്ലീ', llii2: 'ള്ളീ', 
    llo: 'ല്ലൊ', llo2: 'ള്ളൊ', llo3: 'ല്ലോ', llo4: 'ള്ളോ', 
    llu: 'ല്ലു', llu2: 'ള്ളു', 
    lloo: 'ല്ലൂ', lloo2: 'ള്ളൂ', 
    lluu: 'ല്ലൂ', lluu2: 'ള്ളൂ', 
    LL: 'ള്ള്', LL2: 'ല്ല്',  
    LLa: 'ള്ള', LLa2: 'ല്ല', 
    LLaa: 'ള്ളാ', LLaa2: 'ല്ലാ', 
    LLi: 'ള്ളി', LLi2: 'ല്ലി', 
    LLe: 'ള്ളെ', LLe2: 'ല്ലെ', LLe3: 'ള്ളേ', LLe4: 'ല്ലേ', 
    LLee: 'ള്ളീ', LLee2: 'ല്ലീ', LLee3: 'ല്ലേ', LLee4: 'ള്ളേ', 
    LLii: 'ള്ളീ', LLii2: 'ല്ലീ', 
    LLo: 'ള്ളൊ', LLo2: 'ല്ലൊ', LLo3: 'ള്ളോ', LLo4: 'ല്ലോ', 
    LLu: 'ള്ളു', LLu2: 'ല്ലു', 
    LLoo: 'ള്ളൂ', LLoo2: 'ല്ലൂ', 
    LLuu: 'ള്ളൂ', LLuu2: 'ല്ലൂ',
    'l~': 'ൽ', 'l_': 'ൽ',
    la: 'ല', la2: 'ള', laa: 'ലാ', laa2: 'ളാ', lA: 'ലാ',
    li: 'ലി', li2: 'ളി', li3: 'ലൈ', li4: 'ളൈ', lii: 'ലീ',
    lee: 'ലീ', lee2: 'ളീ', lI: 'ലീ', lu: 'ലു', lu2: 'ളു',
    luu: 'ലൂ', luu2: 'ളൂ', loo: 'ലൂ', loo2: 'ളൂ', loo3: 'ലോ',
    lv: 'ല്വ്', lv2: 'ൽവ്', lv3: 'ൾവ്', lv4:'ള്വ്', lw: 'ല്വ്', lw2: 'ൽവ്', lw3: 'ൾവ്', lw4: 'ള്വ്', lva: 'ല്വ', lva2: 'ൽവ', lva3: 'ൾവ', lva4: 'ള്വ', lwa: 'ല്വ', lwa2: 'ൽവ', lwa3: 'ൾവ', lwa4: 'ള്വ',
    lU: 'ലൂ', lR: 'ലൃ', le: 'ലെ', le2: 'ളെ', le3: 'ലേ', 
    le4: 'ളേ', lE: 'ലേ', lE2: 'ളേ', lae: 'ലേ', lai: 'ലൈ',
    lei: 'ലൈ', lo: 'ലൊ', lo2: 'ലോ', lo3: 'ളൊ', lo4: 'ളോ',
    lO: 'ലോ', lau: 'ലൗ', lou: 'ലൗ', laM: 'ലം', laH: 'ലഃ',
    L: 'ൾ', L2: 'ള്', L3: 'എൽ', L4: 'ള്ള്', L5: 'ൽ',
    L_: 'ൾ', 'L~': 'ൾ',
    La: 'ള', La2: 'ല', Laa: 'ളാ', Laa2: 'ലാ', LA: 'ളാ',
    Li: 'ളി', Li2: 'ലി', Lii: 'ളീ', Lee: 'ളീ', Lee2: 'ലീ',
    LI: 'ളീ', LI2: 'ലീ', Lu: 'ളു', Lu2: 'ലു',
    Luu: 'ളൂ', Luu2: 'ലൂ', LU: 'ളൂ', LU2: 'ലൂ',
    Loo: 'ളൂ', Loo2: 'ലൂ', LR: 'ളൃ', Le: 'ളെ', Le2: 'ലെ',
    LE: 'ളേ', LE2: 'ലേ', Lae: 'ളേ', Lae2: 'ലേ',
    Lai: 'ളൈ', Lei: 'ളൈ', Lei2: 'ലൈ',
    Lo: 'ളൊ', Lo2: 'ലൊ', Lo3: 'ലോ', LO: 'ളോ',
    Lau: 'ളൗ', Lau3: 'ളൗ', Lou: 'ളൗ', LaM: 'ളം', LaH: 'ളഃ',
    lp: 'ല്‍പ്', lp2: 'ല്പ്', lpa: 'ല്‍പ', lpa2: 'ല്പ', 
    lpaa: 'ല്‍പാ', lpaa2: 'ല്പാ', lpi: 'ല്പി', lpi2: 'ൽപി', lpii: 'ല്പീ', lpii2: 'ൽപീ', lpee: 'ൽപീ', lpee2: 'ല്പീ',
    lpu: 'ല്പു', lpu2: 'ൽപു', lpuu: 'ല്പൂ', lpuu2: 'ൽപ്പ്', lpoo: 'ൽപൂ', lpoo2: 'ല്പൂ', lpU: 'ല്പൂ', lpe: 'ല്പെ', lpe2: 'ല്പേ', lpe3: 'ൽപേ', lpe4: 'ൽപെ', 
    lpE: 'ല്പേ', lpai: 'ല്പൈ', lpai2: 'ൽപൈ', lpei: 'ല്പൈ', lpei2: 'ൽപൈ', lpo: 'ൽപോ', lpo2: 'ല്പൊ',
    lpo3: 'ല്പോ', lpO: 'ൽപൊ', lpO2: 'ല്പോ', lpau: 'ല്പൗ', lpaM: 'ല്പം', lpaM2: 'ല്‍പം', lpaH: 'ല്പഃ',
    ly: 'ല്യ്', lya: 'ല്യ', lyaa: 'ല്യാ',
    Ly: 'ള്യ്', Lya: 'ള്യ', Lyaa: 'ള്യാ',
    v: 'വ്', v2: 'വു', v3: 'വ്വ്', v4: 'വ്വു', v5: 'വി',
    V: 'വി',
    va: 'വ', va2: 'വാ',
    Va: 'വ', Va2: 'വ്വ', Va3: 'വാ',
    vaa: 'വാ',
    Vaa: 'വാ', Vaa2: 'വ്വാ',
    vA: 'വാ',
    vi: 'വി',
    Vi: 'വി',
    vii: 'വീ',
    vee: 'വീ', vee2: 'വേ',
    vI: 'വീ',
    vu: 'വു',
    vuu: 'വൂ',
    voo: 'വൂ',
    vU: 'വൂ',
    vR: 'വൃ',
    ve: 'വെ', ve2: 'വേ',
    vE: 'വേ',
    vae: 'വേ',
    vai: 'വൈ', vai2: 'വയ്',
    vei: 'വൈയ്', vei2: 'വൈ',
    vo: 'വൊ', vo2: 'വോ',
    vO: 'വോ',
    vau: 'വൗ',
    vou: 'വൗ',
    vaM: 'വം',
    vaH: 'വഃ',
    w: 'വ്', w2: 'വ്വ്', w3: 'ഡബ്ല്യൂ',
    wa: 'വ',
    waa: 'വാ',
    wA: 'വാ',
    wi: 'വി',
    wii: 'വീ',
    wee: 'വീ',
    wI: 'വീ',
    wu: 'വു',
    wuu: 'വൂ',
    woo: 'വൂ',
    wU: 'വൂ',
    wR: 'വൃ',
    we: 'വെ', we2: 'വേ',
    wE: 'വേ',
    wae: 'വേ',
    wai: 'വൈ',
    wei: 'വൈ',
    wo: 'വൊ', wo2: 'വോ',
    wO: 'വോ',
    wau: 'വൗ',
    wou: 'വൗ',
    waM: 'വം',
    waH: 'വഃ',
    W: 'വ്', W2: 'വ്വ്', W3: 'ഡബ്ല്യൂ',
    Wa: 'വ',
    Waa: 'വാ',
    WA: 'വാ',
    Wi: 'വി',
    Wii: 'വീ',
    Wee: 'വീ',
    WI: 'വീ',
    Wu: 'വു',
    Wuu: 'വൂ',
    Woo: 'വൂ', Woo2: 'വോ',
    WU: 'വൂ',
    WR: 'വൃ',
    We: 'വെ', We2: 'വേ',
    WE: 'വേ',
    Wae: 'വേ',
    Wai: 'വൈ',
    Wei: 'വൈ',
    Wo: 'വൊ', Wo2: 'വോ',
    WO: 'വോ',
    Wau: 'വൗ',
    Wou: 'വൗ',
    WaM: 'വം',
    WaH: 'വഃ',
    s: 'സ്', s2: 'ശ്', s3: 'സ്സ്', s4: 'എസ്',
    sa: 'സ', sa2: 'ശ',
    saa: 'സാ', saa2: 'ശാ',
    sA: 'സാ',
    si: 'സി', si2: 'ശി',
    sii: 'സീ', sii2: 'ശീ',
    see: 'സീ', see2: 'ശീ',
    sI: 'സീ', sI2: 'ശീ',
    su: 'സു', su2: 'ശു',
    suu: 'സൂ', suu2: 'ശൂ',
    soo: 'സൂ', soo2: 'ശൂ',
    sU: 'സൂ',
    sR: 'സൃ',
    se: 'സെ', se2: 'സി', se3: 'സേ',
    sE: 'സേ',
    sae: 'സേ',
    sai: 'സൈ',
    sai2: 'സായ്',
    sei: 'സൈ',
    so: 'സൊ', so2: 'ശൊ', so3: 'സോ', so4: 'ശോ',
    sO: 'സോ',
    sau: 'സൗ',
    sou: 'സൗ',
    saM: 'സം',
    saH: 'സഃ',
    S: 'ശ്', S2: 'സ്', S3: 'ശ്ശ്', S4: 'ശ്ശു്', S5: 'എസ്',
    Sa: 'ശ', Sa2: 'സ',
    Saa: 'ശാ', Saa2: 'സാ',
    SA: 'ശാ', SA2: 'സാ',
    Si: 'ശി', Si2: 'സി',
    Sii: 'ശീ',
    See: 'ശീ', See2: 'സീ',
    SI: 'ശീ',
    Su: 'ശു', Su2: 'സു',
    Suu: 'ശൂ',
    Soo: 'ശൂ', Soo2: 'സൂ',
    SU: 'ശൂ',
    SR: 'ശൃ',
    Se: 'ശെ', Se2: 'സെ', Se3: 'സി', Se4: 'ശി',
    SE: 'ശേ',
    Sae: 'ശേ',
    Sai: 'ശൈ', Sai2: 'സൈ', Sai3: 'സായ്',
    Sei: 'ശൈ', Sei2: 'സീ',
    So: 'ശൊ', So2: 'സൊ', So3: 'സോ',
    SO: 'ശോ',
    Sau: 'ശൗ',
    Sou: 'ശൗ', Sou2: 'സൗ',
    SaM: 'ശം',
    SaH: 'ശഃ', SaH2: 'ഷാ',
    Z: 'ശ്', Z2: 'സ്', Z3: 'ഇസഡ്',
    z: 'സ്', z2: 'ഴ്', z3: 'ശ്', z4: 'ഇസഡ്',
    za: 'സ', za2: 'ശ',
    zaa: 'ശാ', zaa2: 'സാ',
    zA: 'ശാ',
    zi: 'ശി', zi2: 'സി',
    zii: 'ശീ',
    zee: 'ശീ', zee2: 'സീ',
    zI: 'ശീ',
    zu: 'ശു', zu2: 'സു',
    zuu: 'ശൂ',
    zoo: 'ശൂ', zoo2: 'സൂ',
    zU: 'ശൂ',
    zR: 'ശൃ',
    ze: 'ശെ',
    zE: 'ശേ',
    zai: 'ശൈ',
    zei: 'ശൈ',
    zo: 'ശൊ', zo2: 'ശോ',
    zO: 'ശോ',
    zau: 'ശൗ',
    zou: 'ശൗ',
    zaM: 'ശം',
    zaH: 'ശഃ',
    sh: 'ഷ്', sh2: 'ഷു', sh3: 'ശ്',
    sha: 'ഷ', sha2: 'ശ',
    shaa: 'ഷാ', shaa2: 'ശാ',
    shA: 'ഷാ', shA2: 'ശാ',
    shi: 'ഷി', shi2: 'ശി',
    shii: 'ഷീ', shii2: 'ശീ',
    shee: 'ഷീ', shee2: 'ശീ', shee3: 'ഷേ',
    shI: 'ഷീ', shI2: 'ശീ',
    shu: 'ഷു', shu2: 'ശു',
    shuu: 'ഷൂ', shuu2: 'ശൂ',
    shoo: 'ഷൂ', shoo2: 'ശൂ', shoo3: 'ഷോ', shoo4: 'ശോ',
    shU: 'ഷൂ', shU2: 'ശൂ',
    shR: 'ഷൃ',
    she: 'ഷെ', she2: 'ഷി', she3: 'ഷേ', she4: 'ശെ', she5: 'ശി', she6: 'ശേ',
    shE: 'ഷേ', shE2: 'ശേ',
    shae: 'ഷേ', shae2: 'ശേ',
    shai: 'ഷൈ', shai2: 'ശൈ',
    shei: 'ഷൈ', shei2: 'ശൈ',
    sho: 'ഷൊ', sho2: 'ഷോ', sho3: 'ശൊ', sho4: 'ശോ',
    shO: 'ഷോ', shO2: 'ശോ',
    shau: 'ഷൗ', shau2: 'ശൗ',
    shou: 'ഷൗ', shou2: 'ശൗ',
    shaM: 'ഷം', shaM2: 'ശം',
    shaH: 'ഷഃ', shaH2: 'ശഃ',
    Sh: 'ഴ്', Sh2: 'ഷ്', Sh3: 'ഴു',
    Sha: 'ഴ', Sha2: 'ഷ', Sha3: 'ഷാ',
    Shaa: 'ഴാ',
    ShA: 'ഴാ',
    Shi: 'ഴി',
    Shii: 'ഴീ',
    Shee: 'ഴീ',
    ShI: 'ഴീ',
    Shu: 'ഴു', Shu2: 'ഷു',
    Shuu: 'ഴൂ',
    Shoo: 'ഴൂ', Shoo2: 'ഷൂ',
    ShU: 'ഴൂ',
    ShR: 'ഴൃ',
    ShE: 'ഴേ',
    Shae: 'ഴേ',
    Shai: 'ഴൈ',
    Shei: 'ഴൈ',
    Sho: 'ഴൊ', Sho2: 'ഴോ',
    ShO: 'ഴോ',
    Shau: 'ഴൗ',
    Shou: 'ഴൗ',
    ShaM: 'ഴം',
    ShaH: 'ഴഃ',
    zh: 'ഴ്', zh2: 'ഴു്',
    zha: 'ഴ',
    zhaa: 'ഴാ',
    zhA: 'ഴാ',
    zhi: 'ഴി',
    zhii: 'ഴീ',
    zhee: 'ഴീ',
    zhI: 'ഴീ',
    zhu: 'ഴു',
    zhuu: 'ഴൂ',
    zhoo: 'ഴൂ',
    zhU: 'ഴൂ',
    zhR: 'ഴൃ',
    zhe: 'ഴെ', zhe2: 'ഴേ',
    zhE: 'ഴേ',
    zhae: 'ഴേ',
    zhai: 'ഴൈ',
    zhei: 'ഴൈ',
    zho: 'ഴൊ', zho2: 'ഴോ',
    zhO: 'ഴോ',
    zhau: 'ഴൗ',
    zhou: 'ഴൗ',
    zhaM: 'ഴം',
    zhaH: 'ഴഃ',
    h: 'ഹ്', h2: 'എച്', h3: 'എച്ച്',
    H: 'എച്ച്',
    ha: 'ഹ', ha2: 'ഹാ',
    haa: 'ഹാ',
    hA: 'ഹാ',
    hi: 'ഹി', hi2: 'ഹായ്',
    hii: 'ഹീ',
    hee: 'ഹീ',
    hI: 'ഹീ',
    hu: 'ഹു',
    huu: 'ഹൂ',
    hoo: 'ഹൂ', hoo2: 'ഹോ',
    hU: 'ഹൂ',
    hR: 'ഹൃ',
    he: 'ഹെ', he2: 'ഹി', he3: 'ഹേ',
    hE: 'ഹേ',
    hai: 'ഹൈ', hai2: 'ഹായ്',
    hei: 'ഹൈ', hei2: 'ഹേയ്',
    ho: 'ഹൊ', ho2: 'ഹോ',
    hO: 'ഹോ',
    hau: 'ഹൗ',
    hou: 'ഹൗ',
    haM: 'ഹം',
    haH: 'ഹഃ',
    x: 'ക്ഷ്', x2: 'ക്സ്', x3: 'എക്സ്',
    xa: 'ക്ഷ', xa2: 'ക്സ', xa3: 'ക്സെ',
    xaa: 'ക്ഷാ',
    xA: 'ക്ഷാ',
    xi: 'ക്ഷി', xi2: 'ക്സി',
    xii: 'ക്ഷീ', xii2: 'ക്സീ',
    xee: 'ക്ഷീ', xee2: 'ക്സീ',
    xI: 'ക്ഷീ',
    xu: 'ക്ഷു', xu2: 'ക്സു',
    xuu: 'ക്ഷൂ',
    xoo: 'ക്ഷൂ',
    xU: 'ക്ഷൂ',
    xR: 'ക്ഷൃ',
    xe: 'ക്ഷെ', xe2: 'ക്ഷേ', xe3: 'ക്സെ', xe4: 'ക്സി', xe5: 'ക്ഷി',
    xE: 'ക്ഷേ',
    xai: 'ക്ഷൈ',
    xei: 'ക്ഷൈ',
    xo: 'ക്ഷൊ', xo2: 'ക്ഷോ',
    xO: 'ക്ഷോ',
    xau: 'ക്ഷൗ',
    xou: 'ക്ഷൗ',
    xaM: 'ക്ഷം',
    xaH: 'ക്ഷഃ',
    TT: 'റ്റ്', TT2: 'റ്റു',
    TTa: 'റ്റ', TTa2: 'ട്ട',
    TTaa: 'റ്റാ',
    TTA: 'റ്റാ',
    TTi: 'റ്റി',
    TTii: 'റ്റീ',
    TTee: 'റ്റീ',
    TTI: 'റ്റീ',
    TTI2: 'ടി.ടി.ഐ.',
    TTu: 'റ്റു',
    TTuu: 'റ്റൂ',
    TToo: 'റ്റൂ',
    TTU: 'റ്റൂ',
    TTR: 'റ്റൃ',
    TTR2: 'ടി.ടി.ആർ',
    TTe: 'റ്റെ',
    TTE: 'റ്റേ',
    TTai: 'റ്റൈ',
    TTei: 'റ്റൈ',
    TTo: 'റ്റൊ',
    TTO: 'റ്റോ',
    TTau: 'റ്റൗ',
    TTou: 'റ്റൗ',
    TTaM: 'റ്റം',
    TTah: 'റ്റഃ',
    nk: 'ങ്ക്',
    nk2: 'ങ്കു്',
    nka: 'ങ്ക',
    nkaa: 'ങ്കാ',
    nkA: 'ങ്കാ',
    nki: 'ങ്കി',
    nkii: 'ങ്കീ',
    nkee: 'ങ്കീ',
    nkI: 'ങ്കീ',
    nku: 'ങ്കു', nku2: 'ങ്കൂ',
    nkuu: 'ങ്കൂ',
    nkoo: 'ങ്കൂ',
    nkU: 'ങ്കൂ',
    nkR: 'ങ്കൃ',
    nke: 'ങ്കെ', nke2: 'ങ്കേ',
    nkE: 'ങ്കേ',
    nkai: 'ങ്കൈ',
    nkai2: 'ങ്കായ്',
    nkei: 'ങ്കൈ',
    nko: 'ങ്കൊ', nko2: 'ങ്കോ',
    nkO: 'ങ്കോ',
    nkau: 'ങ്കൗ',
    nkou: 'ങ്കൗ',
    nkaM: 'ങ്കം',
    nkaH: 'ങ്കഃ',
    nc: 'ങ്ക്',
    nch: 'ഞ്ച്',
    ncha: 'ഞ്ച', ncha2: 'ഞ്ചാ',
    nchaa: 'ഞ്ചാ',
    nchA: 'ഞ്ചാ',
    nchi: 'ഞ്ചി',
    nchii: 'ഞ്ചീ',
    nchee: 'ഞ്ചീ',
    nchI: 'ഞ്ചീ',
    nchu: 'ഞ്ചു',
    nchuu: 'ഞ്ചൂ',
    nchoo: 'ഞ്ചൂ',
    nchU: 'ഞ്ചൂ',
    nchR: 'ഞ്ചൃ',
    nche: 'ഞ്ചെ', nche2: 'ഞ്ചി',
    nchE: 'ഞ്ചേ',
    nchai: 'ഞ്ചൈ',
    nchei: 'ഞ്ചൈ',
    ncho: 'ഞ്ചൊ', ncho2: 'ഞ്ചോ',
    nchO: 'ഞ്ചോ',
    nchau: 'ഞ്ചൗ',
    nchou: 'ഞ്ചൗ',
    nchaM: 'ഞ്ചം',
    nchaH: 'ഞ്ചഃ',
    nth: 'ന്ത്', nth2: 'ന്തു', ntha: 'ന്ത', ntha2: 'ന്ദ',
    nthaa: 'ന്താ', nthaa2: 'ന്ദാ', nthA: 'ന്താ',
    nthi: 'ന്തി', nthi2: 'ന്ദി', nthii: 'ന്തീ', nthii2: 'ന്ദീ',
    nthee: 'ന്തീ', nthee2: 'ന്ദീ', nthI: 'ന്തീ',
    nthu: 'ന്തു', nthu2: 'ന്ദു', nthU: 'ന്തൂ',
    nthuu: 'ന്തൂ', nthuu2: 'ന്ദൂ', nthoo: 'ന്തൂ', 
    nthoo2: 'ന്ദൂ', nthoo3: 'ന്തോ', nthoo4: 'ന്ദോ',
    nthR: 'ന്തൃ', nthe: 'ന്തെ', nthe2: 'ന്തേ', nthe3: 'ന്ദേ',
    nthE: 'ന്തേ', nthE2: 'ന്ദേ', nthai: 'ന്തൈ', nthei: 'ന്തൈ',
    ntho: 'ന്തൊ', ntho2: 'ന്തോ', ntho3: 'ന്ദൊ', ntho4: 'ന്ദോ',
    nthO: 'ന്തോ', nthau: 'ന്തൗ', nthou: 'ന്തൗ', nthaM: 'ന്തം', nthaH: 'ന്തഃ',
    nTH: 'ന്ഥ്', nTHa: 'ന്ഥ', nTHaa: 'ന്ഥാ', nTHi: 'ന്ഥി', nTHee: 'ന്ഥീ', 
    nTHii: 'ന്ഥീ', nTHu: 'ന്ഥു', nTHuu: 'ന്ഥൂ', nTHU: 'ന്ഥൂ', nTHoo: 'ന്ഥൂ', nTHe: 'ന്ഥെ',
    nTHe2: 'ന്ഥേ', nTHE: 'ന്ഥേ', nTHai: 'ന്ഥൈ', nTHei: 'ന്ഥൈ', 
    nTHo: 'ന്ഥൊ', nTHo2: 'ന്ഥോ', nTHO: 'ന്ഥോ',
    nTHau: 'ന്ഥൗ', nTHaM: 'ന്ഥം', nTHaH: 'ന്ഥഃ', 
    nt: 'ന്റ്', nta: 'ൻ്റ', nta2: 'ണ്ട', nta3: 'ൻ്റെ',
    ntaa: 'ണ്ടാ', ntaa2: 'ൻ്റാ', ntA: 'ൻ്റ',
    nti: 'ൻ്റി', nti2: 'ണ്ടി', ntii: 'ൻ്റീ', ntee: 'ൻ്റീ',
    ntI: 'ൻ്റീ', ntu: 'ൻ്റു', ntuu: 'ൻ്റൂ', ntoo: 'ൻ്റൂ', ntU: 'ൻ്റൂ', 
    ntR: 'ൻ്റൃ', nte: 'ൻ്റെ', nte2: 'ൻ്റേ',
    ntE: 'ൻ്റേ', ntae: 'ൻ്റേ', ntai: 'ൻ്റൈ', ntei: 'ൻ്റൈ',
    nto: 'ൻ്റൊ', nto2: 'ൻ്റോ', ntO: 'ൻ്റോ', ntau: 'ൻ്റൗ', ntou: 'ൻ്റൗ',
    ntaM: 'ൻ്റം', ntaH: 'ൻ്റഃ',
    Nt: 'ണ്ട്', Nta: 'ണ്ട', Ntaa: 'ണ്ടാ', Nti: 'ണ്ടി', Ntii: 'ണ്ടീ', 
    Ntee: 'ണ്ടീ', Ntu: 'ണ്ടു', Ntuu: 'ണ്ടൂ', Ntoo: 'ണ്ടൂ',  NtU: 'ണ്ടൂ',
    Nte: 'ണ്ടെ', Nte2: 'ണ്ടേ', NtE: 'ണ്ടേ', Ntai: 'ണ്ടൈ', 
    Ntei: 'ണ്ടൈ', Nto: 'ണ്ടൊ', Nto2: 'ണ്ടോ', NtO: 'ണ്ടോ', 
    Ntau: 'ണ്ടൗ', NtaM: 'ണ്ടം', NtaH: 'ണ്ടഃ',
    q: 'ക്യു', q2: 'ക്യൂ',
    Q: 'ക്യൂ',
    Y: 'വൈ',
    X: 'എക്സ്'
};

/*
 * Precomputed lookup indexes over MANGLISH_LAYOUT - built ONCE at module load
 * so keystroke handlers never clone or scan the ~2900-entry table.
 * MANGLISH_LAYOUT itself keeps its original exported shape; read-only
 * consumers should use these instead. Byte-identical results vs the old
 * per-keystroke scans are pinned in manglish-layout.spec.ts.
 */

/**
 * Frozen, prototype-less copy of MANGLISH_LAYOUT: same own keys and values,
 * safe for direct `MANGLISH_LOOKUP[pattern]` access (no Object.prototype
 * hits, no accidental mutation, no per-keystroke `Object.assign` clone).
 */
export const MANGLISH_LOOKUP: Readonly<Record<string, string>> =
    Object.freeze(Object.assign(Object.create(null), MANGLISH_LAYOUT));

/**
 * base pattern (digit-free prefix) -> its suggestion-list keys, i.e. the keys
 * of MANGLISH_LAYOUT equal to `base` or `base + d` (d in 2..7), in the
 * table's insertion order - exactly the list the legacy suggestion
 * component's per-change scan (`_.filter(Object.keys(MANGLISH_LAYOUT), ...)`)
 * produced. Note: insertion order is the contract, NOT ascending digits
 * (e.g. 'Pa2' is defined before 'Pa', so the 'Pa' group is ['Pa2', 'Pa']).
 */
export const MANGLISH_ALTERNATES: ReadonlyMap<string, readonly string[]> = (() => {
    const groups = new Map<string, string[]>();
    for (const key of Object.keys(MANGLISH_LAYOUT)) {
        const match = /^(.*?)(\d*)$/.exec(key);
        const base = match[1];
        const digits = match[2];
        if (digits === '' || (digits.length === 1 && digits >= '2' && digits <= '7')) {
            const group = groups.get(base);
            if (group) {
                group.push(key);
            } else {
                groups.set(base, [key]);
            }
        }
    }
    groups.forEach(group => Object.freeze(group));
    return groups;
})();

/**
 * Suggestion keys for an in-progress pattern, resolved via the pattern's
 * digit-free base ('ka2' -> ['ka', 'ka2', 'ka3', 'ka4']). Returns a shared
 * frozen array - callers that mutate must copy.
 */
export function manglishAlternatesFor(pattern: string): readonly string[] {
    return MANGLISH_ALTERNATES.get(pattern.split(/(\d+)/)[0]) || [];
}
